import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const RegionalOnboardingPhone = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState("1 305 555 0123");

  const handleContinue = () => {
    const currentParams = location.search;
    navigate(`/regional-onboarding_card_id-americanwhite-mobile${currentParams}`);
  };

  return (
    <div className="regional-phone">
      <div className="regional-phone-container">
        {/* Dot Pattern Background */}
        <div className="phone-dot-pattern">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(8)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.1 + (row * 0.05) + (col * 0.03);
                return (
                  <circle
                    key={`${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.secundario}
                    fillOpacity={Math.min(opacity, 0.8)}
                  />
                );
              })
            )}
          </svg>
        </div>

        {/* Header */}
        <div className="phone-header">
          <div className="step-indicator">Step 1 of 8</div>
        </div>

        {/* Title Section */}
        <div className="phone-title-section">
          <h1 className="phone-title">What's your phone number?</h1>
          <p className="phone-subtitle">
            We'll text a code to verify your phone.
          </p>
        </div>

        {/* Phone Input */}
        <div className="phone-input-section">
          <label className="phone-label">Phone number</label>
          <div className="phone-input-wrapper">
            <span className="phone-prefix">+</span>
            <input
              type="tel"
              className="phone-input"
              placeholder="e.g. 123 456 7890"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, ''))}
            />
          </div>
        </div>

        {/* Action Button */}
        <div className="phone-actions">
          <button
            className="btn-continue"
            style={{ backgroundColor: colors.primario }}
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>

        {/* Bottom Dot Pattern */}
        <div className="phone-dot-pattern-bottom">
          <svg width="200" height="100" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(4)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.3 - (row * 0.05);
                return (
                  <circle
                    key={`bottom-${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.primario}
                    fillOpacity={Math.max(opacity, 0.1)}
                  />
                );
              })
            )}
          </svg>
        </div>
      </div>
    </div>
  );
};
